import { render, staticRenderFns } from "./TaskStart.vue?vue&type=template&id=544deb46&scoped=true&"
import script from "./TaskStart.vue?vue&type=script&lang=js&"
export * from "./TaskStart.vue?vue&type=script&lang=js&"
import style0 from "./TaskStart.vue?vue&type=style&index=0&id=544deb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544deb46",
  null
  
)

export default component.exports